import type { SkillCertificate } from "../../lib/learning/types";
import { usePortalLocale } from "../../lib/i18n/usePortalLocale";

export function CertificateAttestationSummary({ cert }: { cert: SkillCertificate }) {
  const { strings: s } = usePortalLocale();
  const streak = cert.streak_days ?? 0;
  const consistency = cert.consistency_pct ?? 0;
  const reviews = cert.topic_reviews ?? 0;
  return (
    <p className="text-muted-foreground text-xs tabular-nums">
      {s.certAttestation(Math.round(cert.score * 100), streak, consistency, reviews)}
    </p>
  );
}
